"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setRecipientSelectedState')(function setRecipientSelectedState(viewstate, isSelected) {
    viewstate.isSelected = isSelected;
});
//# sourceMappingURL=setRecipientSelectedState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setRecipientSelectedState.js
// module id = 2764
// module chunks = 2 3